import { Box, Grid, Paper, Skeleton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MatterDetailSkeleton = () => (
  <Wrapper aria-busy="true" aria-label="Loading matter">
    <HeaderRow>
      <Skeleton variant="rounded" width={24} height={24} />
      <Skeleton variant="text" width={120} height={28} />
      <Skeleton variant="rounded" width={80} height={28} />
    </HeaderRow>
    <Grid container spacing={3} sx={{ mt: 0 }}>
      <Grid size={{ xs: 12, md: 4 }} sx={{ order: { xs: 2, md: 0 } }}>
        <SkeletonPaper variant="outlined">
          <Skeleton variant="text" width={80} height={28} />
          <Stack spacing={1.5} sx={{ mt: 2 }}>
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="95%" height={20} />
            <Skeleton variant="text" width="70%" height={20} />
          </Stack>
        </SkeletonPaper>
      </Grid>
      <Grid size={{ xs: 12, md: 8 }} sx={{ order: { xs: 1, md: 0 } }}>
        <SkeletonPaper variant="outlined">
          <Skeleton variant="rounded" width={120} height={32} sx={{ mb: 2 }} />
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="100%" height={20} sx={{ mt: 1 }} />
          <Skeleton variant="text" width="80%" height={20} />
        </SkeletonPaper>
      </Grid>
    </Grid>
  </Wrapper>
);

const Wrapper = styled(Box)(() => ({
  minHeight: 200,
}));

const HeaderRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(2),
}));

const SkeletonPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  minHeight: 200,
}));
